import * as _ from 'lodash'
import {IBusinessObject, IBusinessObjectCreateLoadOptions} from '../PA.Core/PA.Core.IF.BO';
import {IMessageProvider, IProgressProvider, MessageType} from '../PA.Core/PA.Core.IF.Basic';
import {PAdbContext} from '../PA.Core/PAdbContext';
import {IdentityProvider} from '../PA.Core/Basic/Identity'
import {MessageProvider} from '../PA.Core/Basic/Messages'
import {ProgressProvider} from '../PA.Core/Basic/Progress'
import {
    WB_CompanyRow,
    WB_GeneralLedgerPolicyAccountRow,
    WB_GeneralLedgerPolicyRow,
    WB_MasterDataSetRow,
} from "../PA.Core/PAdbSchemaRows";
import {IwbGeneralLedgerPolicy} from "../PA.Core/PAdbSchemaRowsIF";
import {
    esWB_Company,
    esWB_General_Ledger_Policy,
    esWB_General_Ledger_Policy_Account,
    esWB_MasterData_Set,
} from "../PA.Core/PAdbSchema";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import {CreateOptions, ESRecordResolver} from "../PA.Core/lib/ESRecordResolver"
import {ASync} from "../PA.Core/Basic/ASync"
import {GeneralLedgerPolicyBOAudit} from "./GeneralLedgerPolicyBO.Audit";
import {GeneralLedgerPolicyBOValidations} from "./GeneralLedgerPolicyBO.Validations";
import {LeaseRegistry} from "../PA.Utils/LeaseRegistry";
import {AuditService} from "../PA.Core/Security/AuditService";
import {PAEnvironment} from "../PA.Core/PAEnvironment";


export interface IGeneralLedgerPolicyLoadOptions {
    dbContext?: PAdbContext
}

const GeneralLedgerPolicyLoadOptions_default: IGeneralLedgerPolicyLoadOptions = {}

export interface IGeneralLedgerPolicySaveValidateOptions {
    Validate?: {
        bSkipAllValidations?: boolean
    },
    Save?: {}
}

const GeneralLedgerPolicySaveValidateOptions_default: IGeneralLedgerPolicySaveValidateOptions = {
    Validate: {
        bSkipAllValidations: false
    },
    Save: {}
}

export class GeneralLedgerPolicyBO implements IBusinessObject
{
    Identity: IdentityProvider;

    CreateOptions: any;

    LoadOptions: any;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_GeneralLedgerPolicy: WB_GeneralLedgerPolicyRow;

    constructor(options?: IBusinessObjectCreateLoadOptions) {

        this.CreateOptions = options || {};

        if('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({id: 0, name: 'New General Ledger Policy'});

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = null;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_GeneralLedgerPolicy = undefined;
    }

    get WB_GeneralLedgerPolicy(): WB_GeneralLedgerPolicyRow
    {
        return this.drWB_GeneralLedgerPolicy;
    }


    //<editor-fold desc = "IBusinessObject operations">

    LoadNew(options?: IBusinessObjectCreateLoadOptions): Promise<IBusinessObject> {
        debugger
        const self = this;
        this.LoadProgressProvider.start("Creating General Ledger Policy");
        let internalOnComplete = self._OnLoadComplete = (async() => {
            try{
            self.LoadOptions = options || {};
            if('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if(this.dbContext == null) {
                var sError = "Unable to determine dbContext for new General Ledger Policy.";
                self._OnLoadComplete = null;
                self.LoadProgressProvider.exception(sError);
                return self;
            }

            // Create record using dbContext
           let  newGeneralLedgerPolicyRow: WB_GeneralLedgerPolicyRow=<WB_GeneralLedgerPolicyRow> await this.dbContext.createRecordWithKey(esWB_General_Ledger_Policy)
                    newGeneralLedgerPolicyRow.setDefaults()
                    self.drWB_GeneralLedgerPolicy = newGeneralLedgerPolicyRow;
                    self.dbContext.add(esWB_General_Ledger_Policy, newGeneralLedgerPolicyRow)
                    self.Identity.setAll(self.WB_GeneralLedgerPolicy.cif.WB_GLRL_ID, self.WB_GeneralLedgerPolicy.cif.GLRULE_ID, self.WB_GeneralLedgerPolicy.cif.GLRULE_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");


                    self.LoadProgressProvider.finish();
                    self._bIsLoaded = true;
                    self._OnLoadComplete = null;
                await self.applyCreateOptions()
                self.Identity.setAll(self.WB_GeneralLedgerPolicy.cif.WB_GLRL_ID, self.WB_GeneralLedgerPolicy.cif.GLRULE_ID, self.WB_GeneralLedgerPolicy.cif.GLRULE_NAME);
                self.Identity.listenToRecordUpdates(self.WB_GeneralLedgerPolicy, 'WB_GLRL_ID','GLRULE_ID','GLRULE_NAME')

                self.LoadProgressProvider.finish();
                self._bIsLoaded = true;
                self._OnLoadComplete = null;
                return self;
            } catch(err ) {
                self.LoadProgressProvider.exception(err);
                return self
            }})();


    return internalOnComplete;
    }

    async applyCreateOptions() {
        const self = this
        let sName = self.CreateOptions?.sName || self.LoadOptions?.sName
        if (!_.isEmpty(sName))
            self.WB_GeneralLedgerPolicy.cif.GLRULE_NAME = sName

        // Set Master Data Set
        let wbMasterDataSet = self.CreateOptions?.wbMasterDataSetId || self.LoadOptions?.wbMasterDataSetId
        if (_.isNumber(wbMasterDataSet)) {
            let mds: WB_MasterDataSetRow = <any>await self.dbContext.find(esWB_MasterData_Set, wbMasterDataSet)
            if (mds) {
                self.WB_GeneralLedgerPolicy.WB_MasterDataSetRow = mds
                self.WB_GeneralLedgerPolicy.cif.WB_MDSET_ID = wbMasterDataSet
            }
        }

        // Set Company
        let wbCompany = self.CreateOptions?.wbCompanyId || self.LoadOptions?.wbCompanyId
        if (_.isNumber(wbMasterDataSet)) {
            let company: WB_CompanyRow = <any>await self.dbContext.find(esWB_Company, wbCompany)
            if (company) {
                self.WB_GeneralLedgerPolicy.WB_CompanyRow = company
                self.WB_GeneralLedgerPolicy.cif.WB_COMPANY_ID = wbCompany
            }
        }

    }
    Load(anId: number | number, options?: object): Promise<IBusinessObject> {

        var self = this;

        let recordResolver: ESRecordResolver
        let recordResolverLoadPromise: Promise<void>

        self.LoadProgressProvider.start("Loading (" + anId + ")");


        self._OnLoadComplete = new Promise<IBusinessObject>((resolve, error) => {

            if (self.bIsLoaded) {
                self.LoadProgressProvider.exception("General Ledger Policy already loaded.")
                resolve(self); // "Customer already loaded.";
                return;
            }

            self.LoadOptions = options || {};
            _.defaults(self.LoadOptions, GeneralLedgerPolicyLoadOptions_default)


            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else if (_.isEmpty(self.dbContext)) {
                self.dbContext = new PAdbContext({});
            }

            if (_.isEmpty(self.dbContext)) {
                error("Unable to determine dbContext for General Ledger Policy.")
                return;
            }

            if('RecordResolver' in self.LoadOptions) {
                recordResolver = (<any> self.LoadOptions).RecordResolver
                recordResolverLoadPromise = ASync.resolve()
            } else {
                recordResolver = GeneralLedgerPolicyBO.createRecordResolver({dbContext: self.dbContext})
                recordResolverLoadPromise = GeneralLedgerPolicyBO.setupRecordResolver(recordResolver, [anId])
            }


            recordResolverLoadPromise
                .then(function () {
                    let aGeneralLedgerPolicyRow: any = recordResolver.get(esWB_General_Ledger_Policy, anId)

                    if (_.isEmpty(aGeneralLedgerPolicyRow)) {
                        error("General Ledger not Found");
                        return;
                    }

                    self.drWB_GeneralLedgerPolicy = aGeneralLedgerPolicyRow;
                    self.Identity.setAll(self.WB_GeneralLedgerPolicy.cif.WB_GLRL_ID, self.WB_GeneralLedgerPolicy.cif.GLRULE_ID, self.WB_GeneralLedgerPolicy.cif.GLRULE_NAME);
                    self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");
                    self.Identity.listenToRecordUpdates(self.WB_GeneralLedgerPolicy, 'WB_GLRL_ID','GLRULE_ID','GLRULE_NAME')
                    self._bIsLoaded = true
                    self._OnLoadComplete = undefined
                    self.LoadProgressProvider.finish()
                    resolve(self)
                }).catch(function (err: any) {
                self._OnLoadComplete = undefined
                self.LoadProgressProvider.exception(err)
                error(err)
                return;
            });

        });

        return this._OnLoadComplete;
    }

    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }


    Validate(options?: any): Promise<IBusinessObject> {

        var self = this;
        this.ValidateMessageProvider.clearMessages();
        this.ValidateProgressProvider.start("Validating " + self.WB_GeneralLedgerPolicy.cif.GLRULE_NAME + "(" + self.WB_GeneralLedgerPolicy.cif.WB_GLRL_ID + ")");
        return new Promise<IBusinessObject>((resolve, reject) => {
            // Does no validations yet
            self.ValidateOptions = options || {};

            if (self.dbContext == undefined) {
                var sError = "Unable to determine dbContext for to Validate General Ledger Policy.";
                self.ValidateProgressProvider.exception(sError);
                reject(sError);
            }

            GeneralLedgerPolicyBOValidations.Validate(self)
                .then((ignore) => {
                    //return  next validation
                    // ()then hanadler

                    if(self.ValidateMessageProvider.countMessages(MessageType.Error) > 0){
                        self._bIsValidated = false;
                    } else {
                        self._bIsValidated = true;
                    }
                    self.ValidateProgressProvider.finish();
                    resolve(self);

                })
                .catch((err) => {
                    self._bIsValidated = false;
                    self.ValidateProgressProvider.exception(err);
                    resolve(self);

                })

            self._bIsValidated = true;
            self.ValidateProgressProvider.finish();
            resolve(self);
        });
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }


    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    SaveUsing(bBatch: boolean,  options?: any): Promise<IBusinessObject> {

        var self = this;
        var wbGeneralLedgerPolicy = <IwbGeneralLedgerPolicy>self.drWB_GeneralLedgerPolicy;
        let auditService: AuditService = undefined
        this.SaveProgressProvider.start("Saving " + wbGeneralLedgerPolicy.GLRULE_NAME + "(" + wbGeneralLedgerPolicy.WB_GLRL_ID + ")");

        return new Promise<IBusinessObject>( (resolve, reject) => {
            // Doesn't need to do anything yet
            // All the records are in the store, since they were added through find or createNewRecord.
            // -- We could search the tree if the there is any record where store isn't set.

            if(this.dbContext == null) {
                self._bIsSaved = false;
                var sError = "Unable to determine dbContext to Save GeneralLedgerPolicy.";
                self.SaveProgressProvider.exception(sError);
                reject(sError);
                return
            }
            self.SaveOptions = options || {};

            var saveFunction: (esName: string, saveRecords: ESRecord[]| ESRecord, options?: any) => Promise<ESDataStore>
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext)
            }

            let bDone = false
            self.Validate({})
                .then((ignore) => {
                    if (!self.bIsValidated) {
                        self._bIsSaved = false;
                        self.SaveProgressProvider.finish();
                        bDone = true
                        resolve(self);
                        return
                    }
                    return GeneralLedgerPolicyBOAudit.GeneralLedgerPolicyAuditBO(self)
                })
                .then((anAuditService) => {
                    auditService = anAuditService
                    return
                })
                .then(ignore => {
                    if (bDone) return
                    var tasks: Promise<any>[] = []
                    tasks.push(saveFunction(esWB_General_Ledger_Policy, self.drWB_GeneralLedgerPolicy))
                    tasks.push(saveFunction(esWB_General_Ledger_Policy_Account, self.drWB_GeneralLedgerPolicy.WB_GeneralLedgerPolicyAccountRows))
                    tasks.push(saveFunction(esWB_MasterData_Set,self.drWB_GeneralLedgerPolicy.WB_MasterDataSetRow))
                    tasks.push(saveFunction(esWB_Company,self.drWB_GeneralLedgerPolicy.WB_CompanyRow))
                    return Promise.all(tasks)
                })
                .then((ignored) => {
                    if (auditService) {
                        return auditService.Save(bBatch)
                    }
                })
              .then((ignored) => {
                  if (bDone) return
                  if (bBatch) {
                      self.dbContext.addBatchCompleteListener(() => {
                          self._bIsSaved = true;
                          LeaseRegistry.generateLeaseInvalidationByClass(LeaseRegistry.Lease_Type_GLRule);
                      })
                  } else {
                      self._bIsSaved = true;
                      LeaseRegistry.generateLeaseInvalidationByClass(LeaseRegistry.Lease_Type_GLRule);
                  }
                  self.SaveProgressProvider.finish();
                  resolve(self);
              })
              .catch((err) => {
                  self.SaveProgressProvider.exception(err);
                  resolve(self)
              })

        });
    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }

    //Delete
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        var self = this;
        var wbGeneralLedgerPolicy = <IwbGeneralLedgerPolicy>self.drWB_GeneralLedgerPolicy;
        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + wbGeneralLedgerPolicy.GLRULE_NAME + "(" + wbGeneralLedgerPolicy.WB_GLRL_ID + ")");
        return new Promise<IBusinessObject>( (resolve, error) => {

            // 1. Validate if we can delete the GeneralLedgerPolicy

            // 2. If Valid, mark all the records for deletion.
            self.drWB_GeneralLedgerPolicy.markDeleted()

            if(bSaveNow) {
                self.SaveUsing(false)
                    .then((ignore) => {
                        self._bIsDeleted = true;
                        self.DeleteProgressProvider.finish();
                        resolve(self);

                    })
                    .catch((err) => {
                        this.DeleteProgressProvider.exception(err)
                        resolve(self)
                    })
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                resolve(self);
            }
        });
    }


    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }
    //</editor-fold>

    //------------GENERAL LEDGER POLICY ACCOUNT---------------------------------------------------
//<editor-fold desc = "General Ledger Policy Account">
    addGLRLAccount(): Promise<IBusinessObject> {

        var self = this

        return new Promise<IBusinessObject>((resolve, error) => {

            var aGLRLAccountRow: WB_GeneralLedgerPolicyAccountRow = undefined

            self.dbContext.createRecordWithKey(esWB_General_Ledger_Policy_Account)
                .then((aNewRow: WB_GeneralLedgerPolicyAccountRow) => {
                    aNewRow.setDefaults()
                    aGLRLAccountRow = aNewRow
                    aGLRLAccountRow.cif.WB_GLRL_ID = self.drWB_GeneralLedgerPolicy.cif.WB_GLRL_ID
                    self.dbContext.add(esWB_General_Ledger_Policy_Account, aGLRLAccountRow)
                    resolve(self)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    removeGLRLAccount(aGLRLAccountId: number): Promise<IBusinessObject> {
        var self = this

        return new Promise<IBusinessObject>((resolve, error) => {

            _.forEach(self.drWB_GeneralLedgerPolicy.WB_GeneralLedgerPolicyAccountRows, (aGLRLAccountRow: WB_GeneralLedgerPolicyAccountRow) => {
                if(aGLRLAccountRow.isActive && aGLRLAccountRow.cif.WB_GLRLACCT_ID == aGLRLAccountId) {
                    aGLRLAccountRow.markDeleted()
                }
            })

            resolve(self)
        })
    }
//</editor-fold>

    //<editor-fold desc = "Record Resolver operations">
    static createRecordResolver(boLoadOptions: any): ESRecordResolver {

        let opts = boLoadOptions || {}
        let dbContext: PAdbContext

        if ('dbContext' in opts) {
            dbContext = opts.dbContext;
        } else {
            dbContext = new PAdbContext({});
        }
        const wrksp_options: CreateOptions = {
            standardConditions: {
            },
            dctIncludeBelongsToNamedRelations: {
            }
        }

        const aRecResolver = new ESRecordResolver(dbContext, wrksp_options)

        return aRecResolver;

    }

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {

        return new Promise<void>((resolve, error) => {
            recordResolver.findAllWithRelationships(esWB_General_Ledger_Policy,ids).then((result) => {
                resolve()
            }).catch((err) => {
                error(err)
            })
        })
    }

    static concurrentLoadCountHint(): number {
        return 10;
    }

//</editor-fold">

};
PAEnvironment.registerBusinessObjectClass( GeneralLedgerPolicyBO , "GeneralLedgerPolicyBO", "General Ledger Policy")